import { useState, useContext, useEffect, useRef } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import { Box } from "@mui/material";
import {
  AmountBox,
  AppAmountBoxWrapper,
  FilterNonIdeal,
} from "../../../common";
import { AppPagination } from "../../../../Libraries";
import ItemList from "./ItemList";
import QuickSaleListTableHeader from "./QuickSaleListTableHeader";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { useNavigate } from "react-router-dom";
import { useQuickSaleList } from "../../../../hooks/useQuickSaleList";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import {
  DEFAULT_DATE_FILTERS_EXPORT,
  ExpenseCategoryList,
  ITEMS_PER_PAGE,
  NEW_SORT,
  TABLE_FILTERS,
} from "../../../../constants";
import AppTableFilters from "../../../common/AppTableFilters";
import useDownlaodPdf from "../../../../hooks/useDownlaodPdf";
import { useFiltersHandler } from "../../../../hooks/useFilterHandler";
import withObservables from "@nozbe/with-observables";
import { of } from "rxjs";
import {
  buildFiltersConfig,
  getCategoriesByType,
  handleShareDetails,
  mergeCashbookCategories,
} from "../../../../utils";
import { useWalletContext } from "../../../../context/WalletContext";

const QuickSaleList = ({
  accountWrapperClassName,
  accountListBodyWarpperClassName,
  cashbook_categories,
  user,
  business,
  customers,
  initialQuickSale,
} = {}) => {
  const [pageSize, setPageSize] = useState(0);
  const [invoiceCategories, setInvoiceCategories] =
    useState(ExpenseCategoryList);
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const { onDownload, downloadLoading } = useDownlaodPdf(user);
  const [selectedContactId, setSelectedContactId] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const justClosedDropdownRef = useRef(false);

  const {
    filters,
    appliedChips,
    handleFilterChange,
    resetFilters,
    handleRemoveChip,
    isResetFilter,
    setIsResetFilter,
  } = useFiltersHandler(undefined, I18n);

  const {
    quickSaleList,
    handleQuickSale,
    totalQuickSaleFilterCount,
    totalQuickSaleAmount,
    totalPaid,
    totalUnPaid,
    isLoading,
  } = useQuickSaleList(initialQuickSale, ITEMS_PER_PAGE);

  const { accountInfo, fetchAccountInfo, isAccountLoading } =
    useWalletContext();

  useEffect(() => {
    if (cashbook_categories && cashbook_categories?.length) {
      let allCategories = mergeCashbookCategories(cashbook_categories);
      setInvoiceCategories(allCategories);
    }
  }, [cashbook_categories]);

  const initialGetData = () => {
    setPageSize(0);
    handleQuickSale({
      business,
      filters,
      offset: 0,
      limit: ITEMS_PER_PAGE,
    });
  };

  useEffect(() => {
    initialGetData();
  }, [filters]);

  const handleGoDetail = (item) => {
    navigate(`/Accounts/AccountDetail/${item.id}`);
  };

  const handleDownloadReport = (startDate, endDate) => {
    triggerLogEvent(analytics, "quick_sale_report_download");
    let paramsForReport = {
      name: "invoice_statement.pdf",
      template_name: "accountreport_new.hbs",
      business_id: business.id,
      start_date: startDate || "",
      end_date: endDate || "",
      type: "expense",
      invoice_type: "sales",
      pdf: true,
    };

    onDownload(paramsForReport, () => {}, navigate);
  };

  const handleCollectClick = async (item) => {
    setSelectedId(item?.id);

    let info = accountInfo;

    if (!info && user?.phone_number) {
      info = await fetchAccountInfo(navigate);
    }

    handleShareDetails(business.name,info, item, navigate);
  };


  return (
    <Box className={accountWrapperClassName || "AccountWrapper"}>
      <AppTableFilters
        filters={TABLE_FILTERS}
        onFilterChange={handleFilterChange}
        appliedChips={appliedChips}
        filterState={filters}
        onRemoveChip={(chip) => handleRemoveChip(chip)}
        filtersConfig={buildFiltersConfig(TABLE_FILTERS, getCategoriesByType("business_sale"), null, null, null, null, null, null, null, I18n)}
        isResetFilter={isResetFilter}
        setIsResetFilter={setIsResetFilter}
        exportConfig={{
          onExport: handleDownloadReport,
          loading: downloadLoading,
          dateFilters: DEFAULT_DATE_FILTERS_EXPORT,
          applyBtnText: I18n.export,
          spinnerColor: "black",
        }}
      />
      <AppAmountBoxWrapper>
        <AmountBox
          data={[
            {
              amount: formatNum(totalQuickSaleAmount),
              title: I18n.total_sales,
              id: "total_quickSale",
              rsLabel: true,
              amountParaTextClassname: "newFontColor",
            },
            {
              amount: formatNum(totalPaid),
              title: I18n.total_paid_sales,
              id: "total_paid_quickSales",
              rsLabel: true,
              amountParaTextClassname: "newFontColor",
            },
            {
              amount: formatNum(totalUnPaid),
              title: I18n.total_unpaid_sales,
              id: "total_unpaid_quickSales",
              rsLabel: true,
              amountParaTextClassname: "foundationOrangeColor",
            },
          ]}
        />
      </AppAmountBoxWrapper>

      <QuickSaleListTableHeader
        isAscending={filters.sort !== "Oldest"}
        isAscendingStatus={filters.sort !== NEW_SORT.unpaid}
        disabled={!quickSaleList.length}
        handleSort={(tab) => {
          handleFilterChange(
            "sort",
            tab == "status"
              ? filters.sort == NEW_SORT.unpaid
                ? NEW_SORT.blank
                : NEW_SORT.unpaid
              : filters.sort == "Oldest"
                ? "Newest"
                : "Oldest",
          );
        }}
      />
      <Box
        className={`${accountListBodyWarpperClassName || "accountListBodyWarpper"} generic-scrollbar`}
        id="scrollableDiv"
      >
        {quickSaleList.length > 0 ? (
          <AppPagination
            data={{
              handleNext: (e) => {
                if (quickSaleList.length < totalQuickSaleFilterCount) {
                  setPageSize((value) => value + 1);
                  handleQuickSale({
                    business,
                    offset: (pageSize + 1) * ITEMS_PER_PAGE,
                    limit: ITEMS_PER_PAGE,
                    filters,
                    isCalculateTotal: false,
                  });
                }
              },
              pageLoad: true,
              count: totalQuickSaleFilterCount,
              list: quickSaleList,
              scrollableTarget: "scrollableDiv",
            }}
          >
            {quickSaleList.map((item, index) => (
              <ItemList
                key={index}
                index={index}
                quickSale={item}
                business={business}
                isAccountLoading={isAccountLoading}
                contactList={customers}
                onSelect={() => handleGoDetail(item)}
                selectedContactId={selectedContactId}
                setSelectedContactId={setSelectedContactId}
                handleCollectClick={handleCollectClick}
                justClosedDropdownRef={justClosedDropdownRef}
                selectedId={selectedId}
                onEdit={() => {
                  triggerLogEvent(analytics, "quick_sale_edit");
                  navigate(`/QuickSale/QuickSaleForm/Edit/${item.id}`);
                }}
                refetchList={() => {
                  initialGetData();
                }}
              />
            ))}
          </AppPagination>
        ) : !isLoading ? (
          <Box className="h-100">
            <FilterNonIdeal
              title={I18n.no_transactions_matching_those_filters}
              subTitle={I18n.try_adjusting_filters}
              subTitleTextOnClick={() => resetFilters()}
              subTitleText={I18n.reset_small}
            />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

const enhance = withObservables(["business"], ({ business }) => {
  return {
    cashbook_categories: business
      ? business.cashbook_categories.observe()
      : of([]),
    customers: business ? business?.getAllCustomers.observe() : of([]),
    initialQuickSale: business
      ? business.getQuickSale(undefined, undefined, "").observe()
      : of([]),
  };
});

export default enhance(QuickSaleList);
